export * from './data-filter.pipe';



// WEBPACK FOOTER //
// /app/src/app/theme/pipes/dataFilter/index.ts